import { useQuery as d } from "../../../node_modules/@tanstack/react-query/build/modern/useQuery.mjs";
import { useQueryClient as i } from "../../../node_modules/@tanstack/react-query/build/modern/QueryClientProvider.mjs";
import { httpClient as c } from "../../../utils/http-client.mjs";
const C = ({ id: t, fileManagerApiType: e }, s) => {
  const n = i(), r = ["file-details", { id: t }], o = () => e != null && e.isCommon ? "/api/dashboard/management/data-files/" : "/api/dashboard/customer/data-files/";
  return { ...d({
    queryKey: r,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof t < "u",
    queryFn: async ({ queryKey: a }) => {
      const [, { id: u }] = a;
      return (await c.get(o() + u)).data;
    },
    ...s
  }), resetAndRefetch: () => {
    n.invalidateQueries({ queryKey: r });
  } };
};
export {
  C as useFileDetails
};
